import { useMemo } from 'react';

import AIJobProgressLoader, { FileAnalysisSubtitle } from 'components/ai/AIJobProgressLoader';
import SlideoutLoaderContainer from 'components/shared/ai/SlideoutLoaderContainer';
import TimingExplainer from 'components/shared/ai/TimingExplainer';

type Props = {
  retryingTitle: string;
  fileCount: number;
  isProcessing: boolean;
};

export default function AdmissionRetryLoadingState({ retryingTitle, fileCount, isProcessing }: Props) {
  const stages = useMemo(() => [{ title: retryingTitle }, { title: 'Finishing up' }], [retryingTitle]);
  const stage = isProcessing ? 1 : stages.length + 1;

  return (
    <SlideoutLoaderContainer>
      <AIJobProgressLoader
        title='Analyzing Files...'
        subtitle={<FileAnalysisSubtitle fileCount={fileCount} />}
        stages={stages}
        stage={stage}
      />
      <TimingExplainer jobType='summary' />
    </SlideoutLoaderContainer>
  );
}
